import Exim from 'exim';
import _ from 'lodash';
import lazy from './lazy-loader';

let can = {};

const SecurityAPI = {
  loadAll() {
    return lazy.item('/api/user/current/roles');
  }
};

export default Exim.createStore({
  actions: ['canDoAction', 'updateDefaultLocation', 'logout', 'loadAll'],
  initial: {
    can: {}
  },

  logout() {
    this.reset();
    lazy.clear();
    // PermissionStore.can.clear();
  },

  loadAll() {
    can = this.get('can');
    return new Promise((resolve, reject) => {
      return SecurityAPI.loadAll().then((res) => {
        this.set({ can, securityLoadAll: true });
        return resolve(true);
      });
    });
  },

  canDoAction(action, locationId, cb) {
    return SecurityAPI.loadAll().then((res) => {
      if (!res || !res.body) {
        return;
      }
      const resp = res.body.result;
      const location = locationId || this.get('defaultLocation');
      const role = resp.locationRoleMap[location];
      can = this.get('can');
      if (_.isArray(action)) {
        _.each(action, (action) => {
          if (resp.roles[role] != null ? resp.roles[role][`d${action}`] : undefined) {
            return (can[(location + action).replace(/\//g, '-')] = true);
          }
        });
        this.set({ can });
      } else {
        if (resp.roles[role] != null ? resp.roles[role][`d${action}`] : undefined) {
          can[(location + action).replace(/\//g, '-')] = true;
          this.set({ can });
        }
      }
      return typeof cb === 'function' ? cb() : undefined;
    });
  },

  updateDefaultLocation(locationId) {
    // hoping this will trigger a change globally at some point.
    return this.set({
      defaultLocation: locationId
    });
  }
});
